'use es6';

import I18n from 'I18n';
import PropTypes from 'prop-types';
import { Component } from 'react';
import ReactCodeMirror from 'react-codemirror';
import styled from 'styled-components';
import { ExpandableText } from 'foundations-components/transitional/components/ExpandableText';
import { OBSIDIAN } from 'HubStyleTokens/colors';
import { CodeMirrorClassNames, CodeMirrorThemeNames } from '../../../utils/CodeMirrorTheme';

/* Handles the 'Show more' button padding */
import { jsx as _jsx } from "react/jsx-runtime";
const StyledWrapper = styled.div.withConfig({
  displayName: "CodeMirror__StyledWrapper",
  componentId: "sc-139bqkr-0"
})(["button{padding-left:10px;color:", ";}"], OBSIDIAN);
const StyledCodeMirror = styled(ReactCodeMirror).withConfig({
  displayName: "CodeMirror__StyledCodeMirror",
  componentId: "sc-139bqkr-1"
})(["& ", ",& ", "{border-radius:0 0 10px 10px;.CodeMirror-lines{font-size:14px;padding-top:19px;}.CodeMirror-line{padding-left:4.3%;}}"], CodeMirrorClassNames.DARK, CodeMirrorClassNames.LIGHT);
export default class CodeMirror extends Component {
  constructor(...args) {
    super(...args);
    this.refCodemirror = ref => {
      this.codemirror = ref && ref.codemirror;
    };
    this.renderCodeMirror = () => {
      return /*#__PURE__*/_jsx(StyledCodeMirror, Object.assign({
        theme: CodeMirrorThemeNames.DARK,
        width: "100%",
        lineWrapping: true,
        readOnly: true,
        refCodemirror: this.refCodemirror
        // Disables default behavior for tab, which codemirror v5 captures without consent
        ,
        extraKeys: {
          Tab: false
        }
      }, this.props));
    };
  }
  componentDidMount() {
    this.codemirror.refresh();
  }
  render() {
    return /*#__PURE__*/_jsx(StyledWrapper, {
      children: this.props.collapsible ? /*#__PURE__*/_jsx(ExpandableText, {
        use: "on-dark",
        maxHeight: 440,
        expandButtonText: I18n.text('developer-docs-shared-components.params.body.newExpandButton'),
        collapseButtonText: I18n.text('developer-docs-shared-components.params.body.newCollapseButton'),
        buttonAlign: "left",
        gradientColor: "transparent",
        children: this.renderCodeMirror()
      }) : this.renderCodeMirror()
    });
  }
}
CodeMirror.defaultProps = {
  height: 'auto'
};
CodeMirror.propType = {
  height: PropTypes.string,
  mode: PropTypes.string,
  value: PropTypes.string,
  collapsible: PropTypes.boolean
};